import React, { useRef, useContext, useState, useEffect } from "react";
import { FaPlus } from "react-icons/fa";
import axios from "axios";
import { Link } from "react-router-dom";
import DeleteButton from "../../components/UI/AlertDialog";
import Notification from "../../components/UI/Notification";
import { AuthContext } from "../../contexts/AuthContext";
import Drawer from "../../components/UI/Drawer";
import Modal from "../../components/UI/Modal";
import ReactPaginate from 'react-paginate';
import { X } from "lucide-react";
import { getToken } from "../../utils/tokenUtils";
import { getRoleBasedRoute } from '../../utils/routeUtils';
import DropdownMenu from "../../components/UI/DropdownMenu";
import { MoreVertical, AlertTriangle } from 'lucide-react';

// const API_URL = "https://hrmsnew.prepstripe.com/api"; 

const SwipeRequest = () => {
    const [requests, setRequests] = useState([]);
    const { user } = useContext(AuthContext)
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [editingRequest, setEditingRequest] = useState(null);
    const [filter, setFilter] = useState("All");
    const [notification, setNotification] = useState(null);
    const [formData, setFormData] = useState({
        swipe_type: "Swipe",
        category: "SwipeReq",
        request_date: "",
        in_out_mode: "In",
        in_time: "10:00 AM",
        out_time: "",
        reason: "",
    });
    const token = getToken();
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        perPage: 15,
      });
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    const [isFiltering, setIsFiltering] = useState(false);
    // filter
    const [searchQuery, setSearchQuery] = useState("");
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [activeFilters, setActiveFilters] = useState({});
    const [filteredData, setFilteredData] = useState(requests);
    const [tempFilters, setTempFilters] = useState({});
    const { roles } = useContext(AuthContext);
    const [openMenu, setOpenMenu] = useState(false);
    const buttonRef = useRef(null);

    const getRoleBasedRouteLocal = (route) => {
        return getRoleBasedRoute(route, roles);
    };

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFilterChange = (field, value) => {
        setActiveFilters(prev => ({
        ...prev,
        [field]: value
        }));
    };

    const clearFilters = () => {
        setActiveFilters({});
        setSearchQuery("");
    };

    const clearFilterByKey = (key) => {
        const updatedFilters = { ...activeFilters };
        delete updatedFilters[key];
        setActiveFilters(updatedFilters);
    };

    // Define the filterable columns based on your table structure
    const filterableColumns = [
        { field: "swipe_type", label: "Swipe Type" },
        { field: "request_date", label: "Request Date" },
        { field: "in_out_mode", label: "In/Out Mode" },
        { field: "status", label: "Status" },
    ];

    useEffect(() => {
    if (showFilterMenu) {
        setTempFilters(activeFilters);
    }
    }, [showFilterMenu]);

    useEffect(() => {
        setFilteredData(requests);
    }, [requests]);

    useEffect(() => {
        // Apply both search query and filters
        const normalizedRequests = requests.map(req => ({
            ...req,
            status: req.request?.status || ""
        }));

        let result = normalizedRequests;
        // let result = requests;

        // Apply search query filtering
        if (searchQuery) {
        const lowercasedQuery = searchQuery.toLowerCase();
        result = result.filter((item) => {
            // Search across all relevant fields
            return (
            (item.swipe_type?.toLowerCase().includes(lowercasedQuery)) ||
            (item.request_date?.toLowerCase().includes(lowercasedQuery)) ||
            (item.in_out_mode?.toString().toLowerCase().includes(lowercasedQuery)) ||
            (item.reason?.toLowerCase().includes(lowercasedQuery)) ||
            (item.status?.toLowerCase().includes(lowercasedQuery))  
            );
        });
        }

        // Apply column-specific filters
        Object.entries(activeFilters).forEach(([field, filterValue]) => {
        if (filterValue) {
            result = result.filter(item => {
            const value = item[field];
            if (field === 'created_at' && value) {
                // Date filtering
                const itemDate = new Date(value);
                const day = String(itemDate.getDate()).padStart(2, '0');
                const month = String(itemDate.getMonth() + 1).padStart(2, '0');
                const year = itemDate.getFullYear();
                const formattedDate = `${day}-${month}-${year}`;
                
                return formattedDate.includes(filterValue);
            } else {
                // Standard string filtering
                return value?.toString().toLowerCase().includes(filterValue.toLowerCase());
            }
            });
        }
        });

        const filteringNow = searchQuery.length > 0 || Object.values(activeFilters).some(v => !!v);
        setIsFiltering(filteringNow);
        setFilteredData(result);
    }, [searchQuery, activeFilters, requests]);
        

    function convertTo24HourFormat(time12h) {
        if (!time12h) return "";
        const [time, modifier] = time12h.trim().split(' ');
        let [hours, minutes] = time.split(':');
    
        hours = parseInt(hours, 10);
        if (modifier === 'PM' && hours !== 12) hours += 12;
        if (modifier === 'AM' && hours === 12) hours = 0;
    
        return `${hours.toString().padStart(2, '0')}:${minutes}`;
    }

    // console.log("selected leave: ", editingRequest)
    
    // fetch swipe requests
    const fetchSwipeRequests = async (page = 1) => {
        setLoading(true)
        axios.get(`https://hrmsnew.prepstripe.com/api/swipe-records?page=${page}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}` 
            }
        })
        .then(response => {
            // // console.log("swipe request data: ", response?.data.last_page)
            setLoading(false)
            setRequests(response.data?.data);
            setPagination({
                currentPage: response.data?.current_page || 1,
                totalPages: response.data?.last_page || 1,
                totalItems: response.data?.total || 0,
                perPage: response.data?.per_page || 10,
            });
        })
        .catch(error => {
            setLoading(false)
            console.error("Error fetching swipe requests:", error);
        });
    }

    useEffect(() => {
        if (editingRequest) {
          setFormData({
            ...editingRequest,
            in_time: convertTo24HourFormat(editingRequest?.in_time),
            out_time: convertTo24HourFormat(editingRequest?.out_time),
          });
        }
      }, [editingRequest]);
      
    // Fetch shift change requests from API
    useEffect(() => {
        fetchSwipeRequests();
    }, [token]);
    
    // Update the in_time or out_time based on in_out_mode
    useEffect(() => {
        if (formData.in_out_mode === "In") {
            setFormData(prev => ({ ...prev, out_time: "" }));  // Reset out_time
        } else {
            setFormData(prev => ({ ...prev, in_time: "" }));   // Reset in_time
        }
    }, [formData.in_out_mode]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };


    const handleAddOrEditRequest = async (e) => {
        e.preventDefault();
        
        if (editingRequest) {
            // Update an existing swipe record
            try {
                const response = await fetch(`https://hrmsnew.prepstripe.com/api/swipe-records/${editingRequest.id}`, {
                    method: "PUT",
                    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
                    body: JSON.stringify(formData),
                });
    
                if (response.ok) {
                    setRequests(requests.map(req => req.id === editingRequest.id ? { ...req, ...formData } : req));
                    // setNotification("Swipe request updated successfully");
                    setNotification({
                        message: "Swipe request updated successfully",
                        type: "success"
                    })
                    setEditingRequest(null);
                    resetForm();
                    setShowModal(false);
                } else {
                    const errorData = await response.json();
                    const errorMsg = errorData?.error || "Failed to update swipe request";
                    // setNotification(errorMsg); // ✅ only a string
                    setNotification({
                        message: errorMsg,
                        type: "error"
                    })
                    setShowModal(true);
                }
            } catch (error) {
                setShowModal(true);
                console.error("Error updating request:", error);
                const errorMsg =
                    error?.message ||
                    error?.error ||
                    "An unexpected error occurred while updating the swipe request.";
                // setNotification(errorMsg); // ✅ only a string
                setNotification({
                    message: errorMsg,
                    type: "error"
                })
            }
        } else {
            // Add a new swipe record
            try {
                const response = await fetch("https://hrmsnew.prepstripe.com/api/swipe-records", {
                    method: "POST",
                    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
                    body: JSON.stringify({ ...formData, status: "Pending" }),
                });
    
                if (response.ok) {
                    const newRecord = await response.json();
                    setRequests([newRecord, ...requests]); // prepend new data
                    // setNotification("Swipe request added successfully");
                    setNotification({
                        message: "Swipe request added successfully",
                        type: "success"
                    })
                    setEditingRequest(null);
                    resetForm();
                    setShowModal(false);
                } else {
                    const errorData = await response.json();
                    const errorMsg = errorData.error || "Failed to add swipe request";
                    // setNotification(errorMsg);  // Use only string message
                    setNotification({
                        message: errorMsg,
                        type: "error"
                    })
                    setShowModal(true);
                }
                
            } catch (error) {
                setShowModal(true);
                console.error("Error adding request:", error);
                const errorMsg = error?.error || "Something went wrong. Please try again.";
                // setNotification(errorMsg);
                setNotification({
                    message: errorMsg,
                    type: "error"
                })
            }
            
        }
    };
    
    const handleEdit = (req) => {
        setEditingRequest(req);
        setFormData(req);
        setShowModal(true);
    };

    const handleAdd = () => {
        resetForm()
        // console.log(resetForm())
        setEditingRequest(null);
        setShowModal(true);
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.totalPages) {
          setCurrentPage(newPage);
          fetchSwipeRequests(newPage);
        }
    };

    const renderPageNumbers = () => {
        // console.log("total pages: ", pagination.totalPages)
        const pages = [];
        for (let i = 1; i <= pagination.totalPages; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              className={`px-4 py-2 rounded-md mx-1 ${
                currentPage === i ? "bg-blue-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300"
              }`}
            >
              {i}
            </button>
          );
        }
        return pages;
    };


    const handleDelete = async (id) => {
        try {
            const response = await fetch(`https://hrmsnew.prepstripe.com/api/swipe-records/${id}`, {
                method: "DELETE",
                headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            });
    
            if (response.ok) {
                setRequests(requests.filter(req => req.id !== id));
                // setNotification("Swipe request deleted successfully");
                setNotification({
                    message: "Swipe request deleted successfully",
                    type: "success"
                })
            } else {
                // setNotification("Failed to delete swipe request");
                setNotification({
                    message: "Failed to delete swipe request",
                    type: "error"
                })
            }
        } catch (error) {
            console.error("Error deleting request:", error);
        }
    };
    

    const resetForm = () => {
        setFormData({
            swipe_type: "Swipe",
            category: "SwipeReq",
            request_date: "",
            in_out_mode: "In",
            in_time: "10:00 AM",
            out_time: "",
            reason: "",
        });
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        const filtering = value !== '';
        setIsFiltering(filtering);
      
        if (!filtering) {
          // Search cleared, restore current page's data
          handlePageChange(currentPage); // fetchResponses will be called inside
        }
    };
      

    // table data filteration
    const filteredRequests = filter === "All" 
    ? requests 
    : requests.filter(req => req.request.status.toLowerCase() === filter.toLowerCase());
    
    // Further filter by search term
    // const searchedLeaves = filteredRequests.filter((leave) =>
    //     leave.swipe_type.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //     leave.in_out_mode.toLowerCase().includes(searchTerm.toLowerCase())
    // );
    
    const hasTempFilters = Object.values(tempFilters).some((val) => val !== "");
        
    return (
        <div className="px-4 py-2 bg-white dark:bg-gray-900 rounded-lg font-poppins">
            {/* notification compo */}
            {notification && <Notification message={notification.message} type={notification.type} onClose={() => setNotification(null)} />}

            {/* Breadcrumb */}
            <nav className="flex flex-wrap mb-4 font-poppins" aria-label="Breadcrumb">
                <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
                    <li>
                        <div className="flex items-center">
                            <Link
                            to={getRoleBasedRouteLocal("/admin/attendance_management")}
                            className="text-sm sm:text-md font-medium text-black hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-500"
                            >
                            Attendance Management
                            </Link>
                        </div>
                    </li>
                    <li aria-current="page">
                        <div className="flex items-center">
                        <svg className="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4" />
                        </svg>
                        <span className="ms-1 text-sm sm:text-md font-medium text-gray-500 md:ms-2 dark:text-gray-400">Swipe Requests</span>
                        </div>
                    </li>
                </ol>
            </nav>

            <h2 className="text-lg sm:text-xl dark:text-white font-semibold mb-4">Swipe Requests</h2>

            {/* Actions */}
            <div className="flex flex-col md:justify-between sm:flex-row sm:items-center gap-2 mb-4">


                <div className="flex flex-col md:justify-between sm:flex-row sm:items-center  gap-2">   
                    <button
                        onClick={() => {
                            if (!user.manager) {
                                setNotification({
                                    message: "Manager is not allocated.",
                                    type: "error",
                                });
                                return;
                            }
                            handleAdd(true);
                        }}
                        // onClick={() => handleAdd(true)}
                        className="flex items-center justify-center gap-2 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md">
                        <FaPlus /> Apply Swipe Request
                    </button>
                    {/* search field */}
                    <input
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="w-full dark:bg-black dark:text-white dark:border-gray-700 sm:w-64 placeholder:text-xs md:placeholder:text-sm p-2 border border-gray-300 rounded-md"
                    />
                </div> 

                {/* filter button */}
                <div className="flex justify-between font-poppins gap-2 w-full sm:w-auto">
                    <div className="relative">
                        <button 
                            onClick={toggleFilterMenu}
                            className="p-2 dark:bg-gray-800 dark:text-white dark:border-gray-700 border border-[#F4F7FF] rounded-md flex gap-1 items-center bg-[#F4F7FF] hover:bg-gray-200"
                            >
                            <svg className="dark:text-white" width="18" height="17" viewBox="0 0 13 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.98734 13.5608C7.85034 13.5608 7.71598 13.5252 7.59884 13.4581L5.09834 12.0415C4.817 11.8812 4.58412 11.6552 4.42215 11.3852C4.26017 11.1153 4.17457 10.8104 4.17359 10.5001V7.29493C4.17408 7.06871 4.0996 6.84803 3.96059 6.6638L0.469345 2.02988C0.387822 1.92291 0.339174 1.79674 0.328769 1.66531C0.318364 1.53387 0.346605 1.40228 0.410378 1.28504C0.474151 1.16781 0.570975 1.06949 0.690169 1.00093C0.809362 0.932381 0.94629 0.896259 1.08584 0.896552H11.8333C11.973 0.896002 12.1101 0.931967 12.2295 1.00047C12.3488 1.06896 12.4458 1.16732 12.5096 1.28465C12.5734 1.40198 12.6016 1.5337 12.5911 1.66523C12.5805 1.79677 12.5317 1.92297 12.4498 2.02988L8.95859 6.6638C8.81933 6.84794 8.74458 7.06863 8.74484 7.29493V12.844C8.74465 13.0338 8.66482 13.2158 8.52285 13.3502C8.38088 13.4845 8.18832 13.5603 7.98734 13.5608ZM1.08584 1.60843L4.57109 6.25297C4.80208 6.55645 4.92547 6.92118 4.92359 7.29493V10.4994C4.92387 10.6874 4.9756 10.8722 5.07376 11.0358C5.17192 11.1994 5.31319 11.3362 5.48384 11.433L7.98434 12.8497L7.99484 7.29422C7.99319 6.92039 8.11685 6.55566 8.34809 6.25226L11.8386 1.61834L1.08584 1.60843Z" fill="currentColor"/>
                            </svg>
                            <span className="ml-1">Filter</span>
                        </button>
                        
                        {showFilterMenu && (
                        <div className="absolute dark:bg-gray-900 dark:border-gray-700 z-10 mt-2 md:right-0 right-auto left-0 md:left-auto bg-white border border-gray-200 rounded-md shadow-lg p-4 w-64">
                            <div className="flex justify-between items-center mb-3">
                            <h3 className="font-medium dark:text-white">Filters</h3>
                            
                                {hasTempFilters && (
                                    <button
                                        onClick={() => {
                                        setActiveFilters(tempFilters);
                                        setShowFilterMenu(false);
                                        }}
                                        className=" bg-blue-600 text-white p-2 rounded-md hover:bg-blue-700 text-sm"
                                    >
                                        Apply Filters
                                    </button>
                                )}
 
                            </div>
                            
                            <div className="space-y-3">
                            {filterableColumns.map((column) => (
                                <div key={column.field} className="space-y-1">
                                <label className="block text-sm dark:text-gray-400  font-medium text-gray-700">
                                    {column.label}
                                </label>
                                {column.field === "status" ? (
                                    // Dropdown for status filter
                                    <select
                                    value={tempFilters[column.field] || ""}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setTempFilters(prev => ({ ...prev, [column.field]: value }));
                                    }}
                                    // onChange={(e) => handleFilterChange(column.field, e.target.value)}
                                    className="w-full dark:bg-black dark:text-white dark:border-gray-700 p-2 text-sm border border-gray-300 rounded-md"
                                    >
                                    <option value="">All</option>
                                    <option value="approved">Approved</option>
                                    <option value="pending">Pending</option>
                                    </select>
                                ) : column.field === "request_date" ? (
                                    <input
                                        type="date"
                                        // value={activeFilters[column.field] || ""}
                                        value={tempFilters[column.field] || ""}
                                        // onChange={(e) =>
                                        //     handleFilterChange(column.field, e.target.value) // Store as yyyy-MM-dd
                                        // }
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setTempFilters(prev => ({ ...prev, [column.field]: value }));
                                        }}
                                        className="w-full dark:bg-gray-950 dark:border-gray-700 dark:text-white p-2 text-sm border border-gray-300 rounded-md"
                                    />
                                ) : (
                                    // Text input for other filters
                                    <input
                                    type="text"
                                    value={tempFilters[column.field] || ""}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setTempFilters(prev => ({ ...prev, [column.field]: value }));
                                    }}
                                    // onChange={(e) => handleFilterChange(column.field, e.target.value)}
                                    placeholder={`Filter by ${column.label.toLowerCase()}`}
                                    className="w-full dark:bg-black dark:text-white dark:border-gray-700 p-2 text-sm border border-gray-300 rounded-md"
                                    />
                                )}
                                </div>
                            ))}
                            </div>
                            
                            {isFiltering && (
                            <div className="mt-3 pt-3 border-t border-gray-200">
                                <p className="text-sm text-gray-600">
                                Showing {filteredData.length} of {requests.length} results
                                </p>
                            </div>
                            )}
                        </div>
                        )}
                    </div>
            

                    {isFiltering && (
                    <div className="flex flex-wrap gap-2">
                        {Object.entries(activeFilters).map(([key, value]) => (
                        value && (
                            <div
                            key={key}
                            className="flex items-center gap-2 px-3 py-1.5 border border-blue-500 bg-blue-50 text-blue-600 rounded-full text-sm shadow-sm"
                            >
                            <span className="capitalize">{key.replace('_', ' ')}: {value}</span>
                            <button
                                onClick={() => clearFilterByKey(key)}
                                className="w-5 h-5 flex items-center justify-center rounded-full hover:bg-blue-100 focus:outline-none"
                                aria-label={`Clear ${key}`}
                            >
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth={2}
                                >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                            </div>
                        )
                        ))}
                        <button
                        onClick={clearFilters}
                        className="ml-2 text-sm text-red-500 hover:underline"
                        >
                        Clear All
                        </button>
                    </div>
                    )}
                </div>

            </div>

            {/* Requests Table */}
            <div className="overflow-x-auto bg-white dark:bg-gray-900 shadow-md rounded-lg">
                <table className="w-full table-auto md:table-fixed text-sm">
                    <thead className="bg-gray-100 dark:bg-gray-800 dark:text-white">
                        <tr>
                            <th className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">Requested Date</th>
                            <th className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">In/Out Mode</th>
                            <th className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">Reason</th>
                            <th className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">Status</th>
                            <th className="py-2 px-4 dark:text-white text-center font-semibold text-xs md:text-sm text-black whitespace-nowrap">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                    {loading ? (
                        <tr className="border-b hover:bg-gray-100 dark:hover:bg-gray-800">
                            <td colSpan="6" className="py-2 px-4 text-xs md:text-sm whitespace-nowrap">
                                <div className="animate-spin h-6 w-6 border-2 border-blue-500 border-t-transparent rounded-full mx-auto mb-2 mt-2"></div>
                            </td>
                        </tr>
                    ) : (
                        filteredData.length > 0 ? (
                            filteredData?.map((req) => (
                            <tr key={req.id} className="dark:border-gray-700 dark:hover:bg-gray-950 dark:hover:text-white dark:text-white">
                                <td className="py-2 px-4 dark:text-white text-xs md:text-sm whitespace-nowrap">{req.request_date}</td>
                                <td className="py-2 px-4 dark:text-white text-xs md:text-sm whitespace-nowrap">{req.in_out_mode}</td>
                                <td title={req.reason} className="p-2 dark:text-white truncate whitespace-nowrap">{req.reason}</td>
                                <td className={`py-2 dark:text-white capitalize px-4 text-xs md:text-sm whitespace-nowrap ${req.request.status === "approved" ? "text-green-600" : req.request.status === "rejected" ? "text-red-600" : "text-yellow-600"}`}>
                                {req.request.status}
                                </td>
                                <td className="p-2 flex justify-center gap-2 whitespace-nowrap">

                                    <button
                                        ref={buttonRef}
                                        className=""
                                        onClick={() => setOpenMenu((prev) => !prev)}
                                        >
                                        <MoreVertical className="w-4 h-4 text-gray-600 dark:text-gray-400" />   
                                    </button>

                                    {openMenu && (
                                        <DropdownMenu
                                            buttonRef={buttonRef}
                                            onClose={() => setOpenMenu(false)}
                                        >
                                            <button
                                            className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
                                            onClick={() => {
                                                setSelectedRequest(req);
                                                setDrawerOpen(true);
                                                setOpenMenu(false);
                                            }}
                                            >
                                            View
                                            </button>
                                            {req.request.status === "pending" && (
                                            <button
                                                className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
                                                onClick={() => {
                                                handleEdit(req);
                                                setOpenMenu(false);
                                                }}
                                            >
                                                Edit
                                            </button>
                                            )}
                                            <DeleteButton
                                            style={
                                                "block w-full text-left px-4 py-2 text-sm text-red-500 hover:bg-gray-100 dark:hover:bg-gray-700"
                                            }
                                            onDelete={() => {
                                                handleDelete(req.id);
                                                setOpenMenu(false);
                                            }}
                                            />
                                        </DropdownMenu>
                                    )}
                                </td>
                            </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={6} className="text-center dark:text-white text-gray-500 p-2">No record found</td>
                            </tr>
                        )
                    )}
                    </tbody>
                </table>
            </div>

            {!isFiltering && filteredData?.length > 0 && (
                <ReactPaginate
                    breakLabel="..."
                    onPageChange={(event) => handlePageChange(event.selected + 1)}
                    forcePage={currentPage - 1} 
                    pageRangeDisplayed={5}
                    pageCount={pagination.totalPages}
                    renderOnZeroPageCount={null}
                    nextLabel="Next >"
                    previousLabel="< Prev"
                    previousClassName='dark:text-white px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-50 dark:border-gray-600 dark:hover:bg-gray-800'
                    nextClassName="dark:text-white px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-50 dark:border-gray-600 dark:hover:bg-gray-800"
                    containerClassName="flex items-center justify-center mt-4 font-poppins"
                    pageClassName="mx-1 px-3 py-1 border rounded dark:text-white font-poppins"
                    activeClassName="bg-blue-500 text-white dark:bg-black dark:text-white dark:border-gray-700 font-poppins"
                />
            )}

            {/* Swipe request form (Modal) */}
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-end md:items-center z-50 backdrop-blur-sm" onClick={() => { setShowModal(false); setEditingRequest(null); }}>
                    {/* Modal Container */}
                    <div
                        className="bg-white font-poppins dark:bg-gray-900 rounded-t-2xl md:rounded-lg shadow-xl w-full max-w-md mx-auto relative transition-transform duration-300 transform md:animate-none animate-slideUp"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <form onSubmit={handleAddOrEditRequest} className=" bg-white dark:bg-gray-900 sm:rounded-lg rounded-t-2xl">
                            {/* modal title */}
                            {/* <div className="px-4 py-3 flex justify-between items-center border-b border-gray-300 dark:border-gray-700">
                                <h2 className="md:text-xl dark:text-white text-md font-semibold">
                                    {editingRequest ? "Edit Request" : "Swipe Request"}
                                </h2>
                                <button 
                                    type="button" 
                                    onClick={() => { 
                                        setShowModal(false); 
                                        setEditingRequest(null); 
                                    }} 
                                    className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 hover:text-red-500 dark:text-gray-400 dark:hover:text-red-400 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-300 dark:focus:ring-red-600"
                                    aria-label="Close modal"
                                >
                                    <svg 
                                        className="w-5 h-5" 
                                        fill="none" 
                                        stroke="currentColor" 
                                        viewBox="0 0 24 24" 
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path 
                                            strokeLinecap="round" 
                                            strokeLinejoin="round" 
                                            strokeWidth={2} 
                                            d="M6 18L18 6M6 6l12 12" 
                                        />
                                    </svg>
                                </button>
                            </div> */}

                            <div className="relative">
                                <div className="absolute inset-0 bg-gradient-to-r from-blue-50 to-purple-50 dark:from-gray-800 dark:to-gray-850"></div>
                                <div className="relative flex items-center justify-between p-4 border-b border-gray-200/50 dark:border-gray-700/50">
                                    <div className="flex items-center space-x-3">
                                        <div className="w-1 h-6 bg-gradient-to-b from-blue-500 to-purple-600 rounded-full"></div>
                                        <h2 className="text-xl font-semibold text-gray-900 dark:text-white tracking-tight">
                                            {editingRequest ? "Edit Swipe Request" : "Swipe Request"}
                                        </h2>
                                    </div>
                                    
                                    {/* Enhanced close button */}
                                    <button
                                        type="button"
                                        onClick={() => { 
                                            setShowModal(false); 
                                            setEditingRequest(null); 
                                        }} 
                                        className="group relative p-2 rounded-xl bg-gray-100/80 hover:bg-red-50 dark:bg-gray-800/80 dark:hover:bg-red-900/20 transition-all duration-200 hover:scale-105 active:scale-95"
                                        aria-label="Close modal">
                                        <X 
                                        size={20} 
                                        className="text-gray-600 group-hover:text-red-500 dark:text-gray-400 dark:group-hover:text-red-400 transition-colors duration-200" 
                                        />
                                        <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-red-500/0 to-red-600/0 group-hover:from-red-500/10 group-hover:to-red-600/10 transition-all duration-200"></div>
                                    </button>
                                </div>
                            </div>

                            {/* modal body */}
                            <div className="max-h-[80vh] overflow-y-auto flex flex-col gap-y-2 rounded-lg bg-white dark:bg-gray-900 p-4">

                                {/* type field */}
                                <label className="block md:text-md text-sm dark:text-white">
                                    Type: <span className="text-red-500 ml-1">*</span>
                                    <select required value={formData.swipe_type} onChange={(e) => setFormData({ ...formData, swipe_type: e.target.value })}
                                        className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border p-2 rounded-md mt-1">
                                        <option value="Swipe">Swipe</option>
                                        {/* <option value="OD">OD</option> */}
                                    </select>
                                </label>

                                {/* category field */}
                                {/* <label className="block md:text-md text-sm dark:text-white">
                                    Category: <span className="text-red-500 ml-1">*</span>
                                    <select value={formData.category} onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                                        className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border p-2 rounded-md mt-1">
                                        <option value="SwipeReq">SwipeReq</option>
                                    </select>
                                </label> */}

                                {/* requested date and in/out mode */}
                                <div className="grid grid-cols-2 gap-4 md:text-md text-sm ">
                                    <div className="dark:text-white">
                                        Request Date: <span className="text-red-500 ml-1">*</span>
                                        <input
                                            type="date"
                                            value={formData.request_date}
                                            onChange={(e) => setFormData({ ...formData, request_date: e.target.value })}
                                            min={new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split("T")[0]}
                                            max={new Date().toISOString().split("T")[0]} // Today's date
                                            className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border p-2 rounded-md mt-1"
                                            required
                                        />
                                    </div>

                                    <div className="dark:text-white">
                                        In/Out Mode: <span className="text-red-500 ml-1">*</span>
                                        <select 
                                            value={formData.in_out_mode} 
                                            onChange={(e) => setFormData({ ...formData, in_out_mode: e.target.value })}
                                            required
                                            className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border p-2 rounded-md mt-1">
                                            <option value="In">In</option>
                                            <option value="Out">Out</option>
                                        </select>
                                    </div>
                                </div>

                                {/* In Time/Out Time */}
                                <div className="grid grid-cols-2 gap-4 md:text-md text-sm">

                                    {/* Conditionally Render In Time or Out Time */}
                                    {formData.in_out_mode === "In" && (
                                        <div className="mb-4">
                                            <label className="block dark:text-white text-gray-700 font-medium mb-1">In Time: <span className="text-red-500 ml-1">*</span></label>
                                            <input 
                                                type="time" 
                                                name="in_time" 
                                                value={formData.in_time} 
                                                onChange={handleChange} 
                                                required
                                                className="border dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 p-2 rounded-md w-full"
                                            />
                                        </div>
                                    )}
                                    {formData.in_out_mode === "Out" && (
                                        <div className="mb-4">
                                            <label className="block dark:text-white text-gray-700 font-medium mb-1">Out Time: <span className="text-red-500 ml-1">*</span></label>
                                            <input 
                                                type="time" 
                                                name="out_time" 
                                                value={formData.out_time} 
                                                onChange={handleChange} 
                                                required
                                                className="border dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 p-2 rounded-md w-full"
                                            />
                                        </div>
                                    )}
                                </div>
                                
                                {/* reason field */}
                                <label className="block md:text-md text-sm dark:text-white">
                                    Reason: <span className="text-red-500 ml-1">*</span>
                                    <textarea
                                        value={formData.reason}
                                        onChange={(e) => {
                                            const input = e.target.value;
                                            const filteredInput = input.replace(/[^a-zA-Z\s.,!?']/g, '');
                                            setFormData({ ...formData, reason: filteredInput });
                                        }}
                                        maxLength={20}
                                        required
                                        className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border p-2 rounded-md"
                                    ></textarea>
                                    <p className="text-sm text-gray-500 mt-1">{formData.reason.length}/20 characters</p>
                                </label>
                            </div>

                            <hr className="text-gray-300 dark:border-gray-700"/>

                            {/* modal footer */}
                            <div className="px-4 py-5 flex justify-between items-center">
                                <button
                                    onClick={() => { setShowModal(false); setEditingRequest(null); }}
                                    className="bg-gray-500 dark:bg-black hover:bg-gray-600 text-white px-10 py-2 rounded-md"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="bg-blue-500 hover:bg-blue-600 text-white px-10 py-2 rounded-md"
                                >
                                    {editingRequest ? "Update" : "Save"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* drawer to view details */}
            <Drawer
                isOpen={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                ChilDiv=""
                ChildParent=""
                showClose={false}
                height_width="w-full max-w-3xl px-6 py-6 md:rounded-3xl"
                >
                {selectedRequest && (
                    <div className="space-y-6 p-4">
                    {/* Header */}
                    <div className="flex items-center justify-between border-b pb-4">
                        <h3 className="text-xl md:text-2xl font-semibold dark:text-white text-gray-800">
                        🕒 Swipe Request Details
                        </h3>
                        <div className="flex items-center gap-3">
                        <span
                            className={`text-sm font-semibold px-3 py-1 rounded-full
                            ${selectedRequest.request.status === 'approved'
                                ? 'bg-green-100 text-green-600'
                                : selectedRequest.request.status === 'rejected'
                                ? 'bg-red-100 text-red-600'
                                : 'bg-yellow-100 text-yellow-600'}`}
                        >
                            {selectedRequest.request.status || 'pending'}
                        </span>
                        <button
                            onClick={() => setDrawerOpen(false)}
                            className="text-gray-500 hover:text-red-500 transition"
                        >
                            <X className="w-5 h-5" />
                        </button>
                        </div>
                    </div>

                    {/* Content */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="space-y-4 text-sm text-gray-700">
                        <Detail label="Swipe Type" value={selectedRequest.swipe_type} />
                        <Detail label="Category" value={selectedRequest.category} />
                        <Detail label="Request Date" value={selectedRequest.request_date} />
                        <Detail label="In/Out Mode" value={selectedRequest.in_out_mode} />
                        {selectedRequest.in_time && (
                            <Detail label="In Time" value={selectedRequest.in_time} />
                        )}
                        {selectedRequest.out_time && (
                            <Detail label="Out Time" value={selectedRequest.out_time} />
                        )}
                        <Detail label="Reason" value={selectedRequest.reason} />
                        
                        {selectedRequest.request.approver_comments && selectedRequest.request.action_date && (
                        <>
                            <hr className="my-4" />
                            <Detail label="Approver's Comment" value={selectedRequest.request.approver_comments} />
                            <Detail label={`Request ${selectedRequest.request.status} On`} value={selectedRequest.request.action_date} />
                        </>
                        )}

                        </div>
                    </div>
                    </div>
                )}
            </Drawer>
        </div>
    );
};

const Detail = ({ label, value }) => (
  <div className="flex flex-col font-poppins">
    <span className="text-gray-500 dark:text-white">{label}</span>
    <span className="font-medium text-gray-800 dark:text-gray-500">{value}</span>
  </div>
);


export default SwipeRequest;
